/* src/app/hire-person-search/hire-candidate-slider/hire-slider-education-view/hire-slider-education-view.component.scss */
.clogo {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid rgba(48, 5, 127, 0.04);
  background-color: rgba(48, 5, 127, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  color: #999;
  overflow: auto;
}
.clogo img {
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=hire-slider-education-view.component-OU4I6EKA.css.map */
